import React from 'react';
import Emp from '../Emp/Emp';
import Education from '../Education/Education';

const ReportBasic = (props) => {
    return (
        <div style={{ height: '78vh', overflow: 'auto' }}>
            <div style={{ marginLeft: 16, fontSize: 14, marginBottom: 16, marginTop: 16, fontWeight: 500 }}>
                <div>Хувь хүний мэдээлэл</div>
            </div>
            <Emp />
            <div style={{ marginLeft: 16, fontSize: 14, marginBottom: 16, marginTop: 16, fontWeight: 500 }}>
                <div>Боловсрол</div>
            </div>
            <Education />
        </div>
    );
}

export default ReportBasic;